import {
  composeClassNames,
  ifDefined,
  withDefault,
} from "@faedev/editor-utils";
import { useRouter } from "next/router";
import { CSSProperties, useState } from "react";
import { Alert, Button, Image } from "react-bootstrap";
import ReactPlayer from "src/components/ReactPlayer";
import Translate from "src/components/Translate";
import ValidateContent from "src/components/ValidateContent";
import constants from "src/constants";
import Play from "src/icons/Play";
import { sAlert } from "src/styles/sAlert.module.scss";
import { sButton } from "src/styles/sButton.module.scss";
import { sMuxThumbnail } from "src/styles/sMuxThumbnail.module.scss";
import { sVideoPlayer } from "src/styles/sVideoPlayer.module.scss";
import { ApiThumbnail } from "src/types/ApiThumbnail";
import { ApiVideoNested } from "src/types/ApiVideoNested";

type Props = {
  style?: CSSProperties | null | undefined;
  className?: (string | string) | null | undefined;
  data: ApiVideoNested;
  thumbnail: ApiThumbnail | null | undefined;
  fullWidth?: boolean | null | undefined;
};

/*
function checkResource(url, index) {
  var req = new XMLHttpRequest();
  req.open("HEAD", url, true);
  req.send();
  if (req.status === 404) {
    return index;
  }
  if (req.status === 403) {
    return index;
  }
}
*/

function VideoPlayer({ style, className, data, thumbnail, fullWidth }: Props) {
  const { locale: lang } = useRouter();
  const [available, setAvailable] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [stop, setStop] = useState(false);
  /*
  useEffect(() => {
    if (data && data.url && data.url.length > 0) {
      (async () => {
        try {
          const response = await fetch(data.url, { mode: "no-cors" });
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          } else {
            setAvailable(true);
          }
        } catch (e) {
          setAvailable(false);
        }
      })();
    }
  }, [data]);
  */

  return data ? (
    <>
      {Object.keys(data).length > 0 ? (
        <>
          {data.url ? (
            <ValidateContent
              element={`Video`}
              blocked={withDefault(data.blocked, true)}
              verified={ifDefined(
                data.verified.verified,
                (value) => value,
                () => true
              )}
              privated={withDefault(data.private, false)}
              alerts={false}
            >
              <div
                style={style}
                className={composeClassNames([
                  sVideoPlayer,
                  className,
                  fullWidth && "full-width",
                  "video-player-wrapper",
                ])}
              >
                {constants.Video.sampleVideoCut ? (
                  <>
                    <div
                      style={style}
                      className={composeClassNames([
                        "video-player-cover",
                        playing && "disable",
                      ])}
                    >
                      <ReactPlayer
                        controls={false}
                        width={"100%"}
                        height={"100%"}
                        className={"video-player"}
                        url={data.url}
                        playing={playing}
                        onPlay={() => {
                          setTimeout(() => {
                            setPlaying(false);
                            setStop(true);
                          }, constants.Video.sampleVideoLength);
                        }}
                      />
                    </div>
                    <div
                      style={style}
                      className={composeClassNames([
                        "video-player-play",
                        playing && !stop && "disable",
                      ])}
                      onClick={() => {
                        !stop && setPlaying(true);
                      }}
                    >
                      {stop ? (
                        <Button
                          type={`button`}
                          className={composeClassNames([sButton, "btn-social"])}
                          variant={`primary`}
                        >
                          Jedná se pouze o ukázku.
                        </Button>
                      ) : (
                        <Play
                          className={
                            stop ? "play-button-disable" : "play-button"
                          }
                        />
                      )}
                    </div>
                  </>
                ) : (
                  <ReactPlayer
                    controls={true}
                    width={"100%"}
                    height={"100%"}
                    className={"video-player"}
                    url={data.url}
                  />
                )}
              </div>
            </ValidateContent>
          ) : (
            <div
              className={composeClassNames([sMuxThumbnail, "mux-thumbnail"])}
            >
              {thumbnail && thumbnail.url && thumbnail.url.length > 0 && (
                <Image
                  className="mux-thumbnail-image"
                  src={thumbnail.url}
                  alt={data.title}
                />
              )}
              <Alert variant={`danger`} className={sAlert}>
                <Translate tKey={`Aai. The video failed to load!`} />
              </Alert>
            </div>
          )}
        </>
      ) : null}
    </>
  ) : null;
}

export default VideoPlayer;
